import {SettingsRowValue} from "../../common/CustomTable/CustomTable";
import React from "react";
import {useTranslation} from "react-i18next";
import ThirdPartyUserCredential from "../../../models/thirdparty/ThirdPartyUserCredential";
import SecretPropertiesUserCredentialFormBody from "../userCredential/SecretPropertiesUserCredentialFormBody";

const initialProperties = [
    [{value: 'X-API-Key'}, {value: ''}]
]

function GenAiUserCredentialCustomHeaderFormBody(props) {
    return (
        <SecretPropertiesUserCredentialFormBody {...props} type={ThirdPartyUserCredential.Type.GEN_AI}
            label="header"
            initialProperties={initialProperties} SettingRows={GenAiUserCredentialCustomHeaderFormBodySettingRows}/>
    )
}

function GenAiUserCredentialCustomHeaderFormBodySettingRows(props) {
    const {t} = useTranslation(['thirdPartyService', 'common']);
    const {
        thirdPartyService,
        isDisabled
    } = props;

    return (
        <>
            <SettingsRowValue label={t('thirdPartyService:label.hostname')} value={thirdPartyService.hostname}
                isTight isDisabled={isDisabled}/>
        </>
    )
}

export default GenAiUserCredentialCustomHeaderFormBody;
